var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#99F6E0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hide_pass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M15.5,12.6l-0.8-0.8c0.2-0.9-0.1-1.6-0.7-2.3c-0.6-0.6-1.4-0.9-2.3-0.7l-0.8-0.8 C11,8,11.2,7.9,11.4,7.9c0.2,0,0.4-0.1,0.6-0.1c1,0,1.9,0.4,2.6,1.1c0.7,0.7,1.1,1.6,1.1,2.6c0,0.2,0,0.4-0.1,0.6 C15.6,12.3,15.5,12.5,15.5,12.6z M18.6,15.7l-0.8-0.7c0.6-0.5,1.2-1,1.7-1.6c0.5-0.6,0.9-1.2,1.3-2c-0.8-1.7-2-3-3.6-4 C15.7,6.5,13.9,6,12,6c-0.5,0-1,0-1.4,0.1c-0.5,0.1-0.9,0.2-1.4,0.3L8.4,5.6C9,5.4,9.6,5.3,10.2,5.2S11.4,5,12,5 c2.2,0,4.1,0.6,5.9,1.8c1.8,1.2,3.1,2.8,4,4.7c-0.4,0.8-0.8,1.6-1.4,2.3C20,14.5,19.4,15.1,18.6,15.7z M19.7,21.1l-3.9-3.9 c-0.4,0.2-1,0.4-1.6,0.5C13.5,17.9,12.8,18,12,18c-2.2,0-4.2-0.6-6-1.8c-1.8-1.2-3.1-2.8-4-4.7C2.5,10.6,3,9.8,3.6,9 c0.6-0.8,1.3-1.4,2-1.9L2.9,4.3l0.7-0.7l16.8,16.8L19.7,21.1z M6.4,7.8c-0.6,0.4-1.1,1-1.7,1.6c-0.6,0.7-1.1,1.4-1.4,2.1 c0.8,1.7,2,3,3.6,4c1.6,1,3.3,1.5,5.2,1.5c0.6,0,1.2-0.1,1.8-0.2c0.6-0.1,1-0.2,1.3-0.3l-1.6-1.6c-0.2,0.1-0.4,0.2-0.7,0.2 c-0.3,0.1-0.5,0.1-0.8,0.1c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1.1-1.6-1.1-2.6c0-0.2,0-0.5,0.1-0.7c0.1-0.3,0.1-0.5,0.2-0.7L6.4,7.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlashIcon);
export default __webpack_public_path__ + "static/media/eye-slash-icon.7180579cf8976e20c461bb966aa38be4.svg";
export { ForwardRef as ReactComponent };